import { __assign, __rest } from "tslib";
import * as React from 'react';
import { default as MuiMenuItem } from '@material-ui/core/MenuItem';
export var MenuItem = React.forwardRef(function (props, ref) {
    var button = props.button, other = __rest(props, ["button"]);
    var onKeyDownHandler = function (event) {
        if (event.key === ' ') {
            event.stopPropagation();
            var target = event.target;
            target.click();
        }
    };
    // button as any - https://github.com/mui-org/material-ui/issues/14971
    return React.createElement(MuiMenuItem, __assign({ button: button, onKeyDown: onKeyDownHandler, ref: ref }, other));
});
export default MenuItem;
//# sourceMappingURL=MenuItem.js.map